// extracted by mini-css-extract-plugin
export default {"container":"Form_container__d1xhG","buttonWrapper":"Form_buttonWrapper__tqjiN"};